import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllProducts, toggleProduct } from "./allProductsApi";

export const fetchAllProductsThunk = createAsyncThunk(
    "products/fetchAll",
    async ({ sellerId, filters, pagination }, { rejectWithValue, signal }) => {
        try {
            const data = await fetchAllProducts({ sellerId, filters, pagination }, signal);
            return data;
        } catch (error) {
            console.error("Error in thunk:", error);
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const toggleProductThunk = createAsyncThunk(
    "products/toggleSingle",
    async ({ productId, action }, { rejectWithValue }) => {
        try {
            const response = await toggleProduct(productId, action);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error toggling single product");
        }
    }
);

export const toggleMultipleProductsThunk = createAsyncThunk(
    "products/toggleMultiple",
    async ({ productIds, action }, { rejectWithValue }) => {
        try {
            const results = await Promise.all(productIds.map((id) => toggleProduct(id, action)));
            return results; // array of { productId, action }
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error toggling multiple products");
        }
    }
);
